import React from 'react'
import isBrowser from '../../utils/generalUtils'

import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailIcon,
  EmailShareButton,
  RedditShareButton,
  RedditIcon
} from 'react-share'

const ShareButtons = ({ title, url, twitterHandle, tags, authors }) => {

  return (
    <div>
      <FacebookShareButton url={url} onClick={e => {
        if (isBrowser) {
          window.dataLayer.push({
            event: "facebookShare",
            Author_Name: authors[0].name,
            Author_Name2: (authors[1] ? authors[1].name : ""),
            Content_Name: title,
          });
        }
      }}>
        <FacebookIcon size={40} round={true} />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={title} via={twitterHandle} hashtags={tags} onClick={e => {
        if (isBrowser) {
          window.dataLayer.push({
            event: "twitterShare",
            Author_Name: authors[0].name,
            Author_Name2: (authors[1] ? authors[1].name : ""),
            Content_Name: title,
          });
        }
      }}>
        <TwitterIcon size={40} round={true} />
      </TwitterShareButton>

      <LinkedinShareButton url={url} onClick={e => {
        if (isBrowser) {
          window.dataLayer.push({
            event: "linkedInShare",
            Author_Name: authors[0].name,
            Author_Name2: (authors[1] ? authors[1].name : ""),
            Content_Name: title,
          });
        }
      }}>
        <LinkedinIcon size={40} round={true} />
      </LinkedinShareButton>

      <RedditShareButton url={url} title={title} onClick={e => {
        if (isBrowser) {
          window.dataLayer.push({
            event: "redditShare",
            Author_Name: authors[0].name,
            Author_Name2: (authors[1] ? authors[1].name : ""),
            Content_Name: title,
          });
        }
      }}>
        <RedditIcon size={40} round={true} />
      </RedditShareButton>

      <EmailShareButton url={url} title={title} onClick={e => {
        if (isBrowser) {
          window.dataLayer.push({
            event: "emailShare",
            Author_Name: authors[0].name,
            Author_Name2: (authors[1] ? authors[1].name : ""),
            Content_Name: title,
          });
        }
      }}>
        <EmailIcon size={40} round={true} />
      </EmailShareButton>


    </div>
  )

}
export default ShareButtons